import type { LocaleCode } from '@client-app/i18n';

export const formatUsageTotalLabel = (total: string, isDailyTrialLimit: boolean): string => {
    if (!isDailyTrialLimit) return total;
    return `${total} daily trial limit`;
};

export const formatUsageUtcOffset = (date: Date = new Date()): string => {
    const offsetMinutes = -date.getTimezoneOffset();
    const sign = offsetMinutes >= 0 ? '+' : '-';
    const absOffset = Math.abs(offsetMinutes);
    const hours = String(Math.floor(absOffset / 60)).padStart(2, '0');
    const minutes = String(absOffset % 60).padStart(2, '0');
    return `UTC${sign}${hours}:${minutes}`;
};

export const formatUsageEventTime = (value?: string | null, locale: LocaleCode = 'en') => {
    if (!value) return { localTime: '--', timezone: null as string | null };
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return { localTime: '--', timezone: null as string | null };
    return {
        localTime: new Intl.DateTimeFormat(locale, {
            month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false,
        }).format(date),
        timezone: formatUsageUtcOffset(date),
    };
};
